<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Twice Removed, Roodkapje Anarchive</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">exhibition, anarchive, jello, seeds, audio</p>
        <p>Twice Removed considers preservation and the potential of continuing life. After the fruity workshop during A.S.M.R. [Advanced Social Manner Refusal] I caught a fragment of conversation going on in a corner. Someone said they were going to bring the leftover fruit pits home and plant them. This got me thinking. These pits escaped their fate of being thrown into the bin twice: once from being skipped at the market and finally by being planted. I decided instead of planting to preserve the pits within jello done in the same molds used for the banquet of the performance Sing With Your Mouthful by Singing Club Rotterdam and Eat Your Feelings. </p>

        <p>The installation consists of jello molds in different shapes and sizes made with an agar agar base. Various kinds of fruit pits and seeds are preserved inside. It is accompanied by an audio piece that gives a sonic impression of the Happening that inspired the jello molds. Both pieces are part of the Roodkapje <a href="https://roodkapje.org/anarchief/">anarchive</a>.</p>
        <p>Images by Chris Nelck and Silvia Arenas.</p>
<b-row class="audio">
<b-col md="6">
<audio controls>
  <source src="media/anarchive/anarchive.mp3" type="audio/mp3">
</audio> 
</b-col>
</b-row>
      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/anarchive/smaller_00.png"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/anarchive/small_02.png"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/anarchive/small_05.png"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/anarchive/small_04.png"></b-img>

      </b-col>

       
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'Anarchive',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
